/* PlanSelector.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _22 = "._syazwdcn{color:var(--ds-icon,#44546f)}";
const _21 = "._zulputpp{gap:var(--ds-space-150,9pt)}";
const _20 = "._18u01wug{margin-left:auto}";
const _19 = "._otyr1wug{margin-bottom:auto}";
const _18 = "._2hwx1wug{margin-right:auto}";
const _17 = "._19pk1wug{margin-top:auto}";
const _16 = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const _15 = "._18s8ze3t{margin:var(--ds-space-0,0)}";
const _14 = "._k48p1pd9{font-weight:var(--ds-font-weight-semibold,600)}";
const _13 = "._19it1yif{border:var(--_ahoyl5)}";
const _12 = "._4cvr1y6m{align-items:flex-start}";
const _11 = "._2lx21bp4{flex-direction:column}";
const _10 = "._p12f7ivc{max-width:344px}";
const _9 = "._1bsb1osq{width:100%}";
const _8 = "._2rko1y44{border-radius:4px}";
const _7 = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const _6 = "._1yt4pxbi{padding:var(--ds-space-200,1pc)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import { media, Stack } from '@atlaskit/primitives';
import { Radio } from '@atlaskit/radio';
import Tooltip from '@atlaskit/tooltip';
import { BodySmall, ExternalLink, H6, Link } from '@atlassian/mpac-primitives';
import { Source } from '@atlassian/mpac-types';
import { TooltipDialog } from '@atlassian/mpac-ui';
import { editionConstants, useSource } from '@atlassian/mpac-utils';
import capitalize from 'lodash/capitalize';
import { TEST_IDS } from '../constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "@media not all and (min-width:48rem){._1gde1bp4{flex-direction:column}._ag851y6m{align-items:flex-start}}";
const _4 = "._1wpz1fhb{align-self:stretch}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
const {
  EDITIONS_SUBTITLE_CUSTOMERS,
  EDITIONS_TYPE
} = editionConstants;
const Flex = null;
const FlexColumn = null;
const linkStyles = null;
const planSelectorContainer = null;
const boldTextStyles = null;
const tooltipIconContainerStyles = null;
const radioCardStyles = null;
const planRadioCardSubtextStyles = null;
const PlanSelectorBox = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulppxbi _1e0c1txw _4cvr1h6o _1wpz1fhb _1gde1bp4 _ag851y6m", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PlanSelectorBox.displayName = 'PlanSelectorBox';
}
const RadioCardContainer = _ref2 => {
  let {
    planType,
    isSelected,
    onChange
  } = _ref2;
  const borderStyle = "1px solid ".concat(isSelected ? "var(--ds-border-selected, #0C66E4)" : "var(--ds-border, #091E4224)");
  const handleClickRadio = () => {
    if (!isSelected) {
      onChange({
        label: capitalize(planType),
        value: planType
      });
    }
  };
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8, _2, _9, _10, _11, _12, _13]
    }), /*#__PURE__*/_jsx("div", {
      onClick: handleClickRadio,
      onKeyDown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClickRadio();
        }
      },
      tabIndex: 0,
      role: "radio",
      "aria-checked": isSelected,
      "aria-label": "Select ".concat(EDITIONS_TYPE[planType], " edition"),
      className: ax(["_1yt4pxbi _zulp1b66 _2rko1y44 _1e0c1txw _1bsb1osq _p12f7ivc _2lx21bp4 _4cvr1y6m", "_19it1yif"]),
      style: {
        "--_ahoyl5": ix(borderStyle)
      },
      children: /*#__PURE__*/_jsx(Radio, {
        label: /*#__PURE__*/_jsxs(Stack, {
          space: "space.050",
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_14]
            }), /*#__PURE__*/_jsx(BodySmall, {
              className: ax(["_k48p1pd9"]),
              children: capitalize(planType)
            })]
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_15]
            }), /*#__PURE__*/_jsx(BodySmall, {
              className: ax(["_18s8ze3t"]),
              children: EDITIONS_SUBTITLE_CUSTOMERS[planType]
            })]
          })]
        }),
        isChecked: isSelected
      })
    })]
  });
};
export const PlanSelector = props => {
  const source = useSource();
  const ExplorePricingPlansLink = source === Source.MPAC ? Link : ExternalLink;
  const TooltipContent = () => /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _11]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_1e0c1txw _2lx21bp4"]),
      children: [/*#__PURE__*/_jsx("span", {
        children: "This app offers two different plans - Standard and Advanced. You can start a free trial of either plan, and change your plan anytime during or after the trial."
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_16]
        }), /*#__PURE__*/_jsx(ExplorePricingPlansLink, {
          size: "small",
          href: props.appPricingDetailsLink,
          className: ax(["_19pk1b66"]),
          children: "Explore pricing plans"
        })]
      })]
    })]
  });
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_17, _18, _19, _20, _21, _2, _11, _9]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulputpp _1e0c1txw _2lx21bp4 _1bsb1osq"]),
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_2, _3]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_1e0c1txw _4cvr1h6o"]),
          children: [/*#__PURE__*/_jsx(H6, {
            children: "Select a plan"
          }), /*#__PURE__*/_jsx(Tooltip, {
            component: TooltipDialog,
            position: "bottom-start",
            content: TooltipContent,
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_2, _22]
              }), /*#__PURE__*/_jsx("div", {
                "aria-label": "Select an edition",
                className: ax(["_1e0c1txw _syazwdcn"]),
                children: /*#__PURE__*/_jsx(EditorPanelIcon, {
                  label: "Learn more about app plans",
                  size: "medium",
                  testId: TEST_IDS.PLAN_SELECTOR_TOOLTIP
                })
              })]
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(PlanSelectorBox, {
        children: props.editions.map(edition => /*#__PURE__*/_jsx(RadioCardContainer, {
          planType: edition.value,
          isSelected: props.selectedPlanType.value === edition.value,
          onChange: props.setSelectedPlanType
        }, edition.value))
      })]
    })]
  });
};